module.exports = __webpack_public_path__ + "static/media/KS.aea7efc4.svg";